import { APP_DOMAIN, VIDEO_CALL_URL } from 'appenv';
import { AvailableLocale } from 'i18n/types';
import { stringifyUrl } from 'query-string';

interface VideoCallUrlParams {
  roomToken?: string;
  participantId?: string;
  locale?: string;
  boothId?: string;
  domain?: string;
}

const generateVideoCallLink = (
  roomToken: string,
  uuid: string,
  locale: AvailableLocale,
  boothId: string = null,
) => {
  const query: VideoCallUrlParams = {
    roomToken,
    participantId: uuid,
    domain: APP_DOMAIN,
    locale,
  };
  if (boothId) query.boothId = boothId;

  return stringifyUrl({
    url: VIDEO_CALL_URL,
    query: query as Record<string, string>,
  });
};

export default generateVideoCallLink;
